export default __webpack_public_path__ + "static/media/pic (4).fae089d3.jpg";